import Role from 'modules/Role/Role'
import { Model } from 'pinia-orm'
import { Attr, Uid, Bool, HasManyBy, Num } from 'pinia-orm/dist/decorators'

export class User extends Model {
  static override entity = 'users'

  @Uid() declare id: string
  @Attr(null) declare name: string | null
  @Attr(null) declare email: string | null
  @Attr(null) declare email_verified_at: string | null
  @Attr(null) declare password: string | null

  @Attr(null) declare user_status: string | null
  @Attr(null) declare user_number: number | null
  @Attr(null) declare title: string | null
  @Attr(null) declare mobile: string | null
  @Attr(null) declare primary_phone: string | null
  @Attr(null) declare is_active: boolean | null
  @Attr(null) declare phone_os: string | null
  @Attr(null) declare manages_equipment: boolean | null
  @Attr(null) declare allows_hold_connection: boolean | null
  @Attr(null) declare can_view_levels: boolean | null
  @Attr(null) declare allows_shake: boolean | null
  @Attr(null) declare allows_save_password: boolean | null
  @Attr(null) declare allows_offline_login: boolean | null
  @Attr(null) declare users_x_reference: string | null
  @Attr(null) declare date_created: string | null
  @Attr(null) declare maint_timeouts: boolean | null
  @Attr(null) declare maint_hw_config: boolean | null
  @Attr(null) declare maint_sync_short: boolean | null
  @Attr(null) declare maint_sync_long: boolean | null
  @Attr(null) declare allow_batch_odo: boolean | null
  @Attr(null) declare transaction_types_allowed: string | null
  @Attr(null) declare mkg_tgt: boolean | null
  @Attr(null) declare maint_sync_input_box: boolean | null
  @Attr(null) declare adv_logout: boolean | null
  @Attr(null) declare access_expires: string | null
  @Attr('') declare canonical_status: string
  @Attr(null) declare access_expires_at: string | null
  @Bool(false) declare is_deactivated: boolean
  @Attr(null) declare deactivation_reason: string | null
  @Num(0) declare access_level: number
  @Attr(null) declare level_calibration: boolean | null
  @Attr(null) declare logbook_force_tank_sacn: boolean | null

  @Bool(false) declare can_create_logbook_transaction: boolean
  @Bool(false) declare can_create_bulk_purchase_transaction: boolean
  @Bool(false) declare can_create_fleet_purchase_transaction: boolean
  @Bool(false) declare can_create_adjustment_transaction: boolean
  @Bool(false) declare can_create_transfer_transaction: boolean
  @Bool(false) declare can_create_delivery_transaction: boolean
  @Bool(true) declare can_create_dispense_transaction: boolean

  @HasManyBy(() => Role, 'role_ids') declare roles: Role[]
}
